<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>

div::-webkit-scrollbar {
  display: none;
  width: 0;
}

a {
  color: inherit;
  text-decoration: none;
}

* {
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #2FCCC3 !important;
}

.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
  color: #27AAA3;
  background-color: #fff;
  width: 24rem;
  height: 24rem;
  box-sizing: border-box;
}

.el-pagination button, .el-pagination span:not([class*=suffix]) {
  width: 60rem !important;
  font-size: 11rem;
  line-height: 22rem;
  border-radius: 3rem;
  display: inline;
}

.el-icon-more {
  background: rgba(0, 0, 0, 0) !important;
  color: black !important;
}

.el-icon-more::before {
  color: black !important;
  content: '···';
}

/* .el-icon-more:hover {
  color: red !important;
  content: '···';
} */

.el-pagination.is-background .el-pager li:not(.disabled):not(.active):hover {
  color: #27AAA3 !important;
}

.el-icon-d-arrow-right {
  background: rgba(0, 0, 0, 0) !important;
}

.el-icon-d-arrow-right::before {
  content: '···' !important;
  color: black !important;
}

.el-icon-d-arrow-left {
  background: rgba(0, 0, 0, 0) !important;
  content: '···' !important;
  color: black !important;
}

.el-icon-d-arrow-left::before {
  content: '···' !important;
  color: black !important;
}

.el-pager li {
  font-size: 10.5rem;
  line-height: 25rem;
}
</style>



// WEBPACK FOOTER //
// src/App.vue